import React, { useState, useRef } from 'react';
// utilities
import _slideLoader from '../../utilities/slideLoader';
import { USER_ROLES } from '../../utilities/constants';
// components
import Auth from '../Auth';
import { Unpublished } from '../icons/Unpublished';
import { ExternalServiceCooperationTermsOfServiceDialog } from '../modals/ExternalServiceCooperationTermsOfServiceDialog';

// pages
import { useGetVw } from '../../pages/ExternalServiceCooperation';

export default function UnConnectedContents({ lwApiSettingId }) {
  const [isShowTermsOfServiceDialog, setIsShowTermsOfServiceDialog] = useState(
    false
  );
  const vw = useGetVw();
  const isSending = useRef(false);
  return (
    <React.Fragment>
      <Unpublished className='icon--2_4x ExternalServiceCooperation__contents-status-icon--not-cooperated' />
      <span className='ExternalServiceCooperation__contents-status ExternalServiceCooperation__contents-status--not-cooperated'>
        未連携
      </span>
      <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
        <div className='ExternalServiceCooperation__contents-btn'>
          {/* NOTE: 新規の場合は登録の前に利用規約に同意する */}
          <button
            className='btn'
            onClick={() => setIsShowTermsOfServiceDialog(true)}
          >
            連携する
          </button>
        </div>
      </Auth>
      <ExternalServiceCooperationTermsOfServiceDialog
        visible={isShowTermsOfServiceDialog}
        onClose={() => {
          setIsShowTermsOfServiceDialog(false);
        }}
        onSubmit={() => {
          if (isSending.current) {
            return;
          }
          isSending.current = true;
          setIsShowTermsOfServiceDialog(false);
          moveLwApiSettingRegister(lwApiSettingId, vw);
          isSending.current = false;
        }}
      />
    </React.Fragment>
  );
}

/**
 * @description LINE WORKS 連携情報登録/詳細・編集 画面へ遷移
 */
function moveLwApiSettingRegister(lwApiSettingId, vw) {
  _slideLoader.show(
    'LwApiSettingRegister',
    {
      state: { id: lwApiSettingId },
    },
    vw
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/LwUnConnectedContents.jsx